import instObj from '@/backend/axios-instances'

const resource = "/ticketing/ticket"
const instance = instObj.baseInstance

export default {
  get(ticketId, parameters) {
    return instance.get(`${resource}/${ticketId}`, { params: parameters });
  },
  put(ticketId, data) {
    return instance.put(`${resource}/${ticketId}`, data);
  },
  attachImage(ticketId, data) {
    return instance.post(`${resource}/${ticketId}/images`, data);
  },
  delete(ticketId) {
    return instance.delete(`${resource}/${ticketId}`);
  }
}
